<template>
  <a-layout-content>
    <s-banner></s-banner>
    <div class="notify-content">
      <div class="board_title">
        <p>通知中心</p>
      </div>
      <div class="board_title2">
        <div @click="active=true;$refs.table.refresh()" :class="{active:active}">全部</div>    
        <div @click="active=false;$refs.table.refresh()" :class="{active:!active}">未读</div>
      </div>
      <s-table :data="loadData" :rowSelection="rowSelection"  ref="table" :showSizeChanger="false" :pageSize="10"   :expandRowByClick="true" :expandedRowsChange="expandedRowsChange" >
        <!-- <a-table-column :width="100" title="状态"  dataIndex="isCheck" >
          <input type="checkbox">
        </a-table-column> -->
        <a-table-column :width="100" title="状态"  dataIndex="type">
          <template slot-scope="text, record" >
            <div class="icon-isread" v-if="record.is_read==1">
            </div>
            <div class="icon-isnotread" v-else>
            </div>
          </template>
        </a-table-column>
        <a-table-column title="通知类型" dataIndex="type_">
          <template slot-scope="text,record">
            {{record.notify_type==0?'关键人定位':'系统消息'}}
          </template>
        </a-table-column>
        <a-table-column title="主题" dataIndex="content"> 
          <template slot-scope="text, record" >
            <span class="content-span">
              {{ record.content }}
            </span>
          </template>
        </a-table-column>
        <a-table-column title="时间" dataIndex="created_at"> </a-table-column>
        <a-table-column title="操作" key="action">
          <template slot-scope="record">
            <span   @click.stop="deleteRecord(record.id)" >
              <div class="icon-del" ></div>
            </span>
          </template>
        </a-table-column>
        <div slot="expandedRowRender"   slot-scope="record" style="margin: 0;"><p class="content1">{{record.content1}}</p></div>
      </s-table>
      <div class="board_end" v-if="rowKeys.length>0">
        <div @click="active=true;" :class="{active:active}">
           <a-checkbox @change="batch" :checked="selectedRowKeys.length>0&&rowKeys.length>0&&selectedRowKeys.length==rowKeys.length&&selectedRowKeys.every(m=>rowKeys.includes(m))" ref='batchCheck'>全选</a-checkbox>
        </div>  
        <div ><a-button @click="batchisRead()">设为已读</a-button></div>    
        <div ><a-button @click="batchDeleteRecord()">删除</a-button></div> 
      </div>
    </div>

  </a-layout-content>
</template>
<script>
import Banner from "./banner";
export default {
  components: { "s-banner": Banner },
  data() {
    return {
      d:[],
      active:true,
      selectedRowKeys:[],//已选中的id
      rowKeys:[]//用于全选操作,过滤已读的
    };
  },
  created(){
   
  },
  methods: {
    showConfirm() {
      this.$confirm({
        title: '确认删除选中信息？',
        okText:'是',
        cancelText:'否',
        centered:true,
        onOk() {
          
        }
      });
    },
    loadData(p) {
      return this.$http
        .post("/notifyList", {
          pageNo: (p && p.pageNo) || 1,
          pageSize: (p && p.pageSize) || this.pageSize,
          type:this.active?0:1
        })
        .then(res => {
          console.log(res)
          if (!res.error) {
            let contentEmptyIds=this.d.filter(m=>m.content==='').map(m=>m.id);
            var a = {
              pageNo: parseInt(res.pageNo),
              totalCount: parseInt(res.totalCount),
              result: res.data.list.map((d, i) => {
                d.index = (parseInt(res.pageNo) - 1) * this.pageSize + i + 1;
                d.content1= d.content;
                if (contentEmptyIds&&contentEmptyIds.length>0&&contentEmptyIds.includes(d.id)) {
                  d.content='';
                }
                return d;
              })
            };
            this.pageNo=parseInt(res.pageNo);
            this.rowKeys=a.result.map(m=>m.id);//获取
            console.log(this.rowKeys);
            console.log(a);
            this.d=a.result;
            return a;
          }
        });
    },
    setReadOrDel(ids,type){
      this.$http.post('/setReadOrDel',{id:ids,type:type }).then(
        res=>{
          if (res.error==0) {
            console.log(res)
            this.$refs.table.refresh();
          }
        }
      )
    },
    deleteRecord(id){
      //this.$refs.table.localPagination.current=2;
      let that=this;
      this.$confirm({
        title: '确认删除选中信息？',
        okText:'是',
        cancelText:'否',
        centered:true,
        onOk() {
          if (that.rowKeys.length==1&&that.$refs.table.localPagination.current!=1) {
            that.$refs.table.localPagination.current-=1;
          }
          that.setReadOrDel(id,0);
        }
      });
    },
    isRead(id){
      this.setReadOrDel(id,1);
    },
    batchDeleteRecord(){
      let that=this;
      this.$confirm({
        title: '确认删除选中信息？',
        okText:'是',
        cancelText:'否',
        centered:true,
        onOk() {
          if (that.rowKeys.length>0) {
            if (that.selectedRowKeys.length>0) {
              that.$refs.table.localPagination.current=1;
              that.setReadOrDel(that.selectedRowKeys.join(','),0);
            }
            that.selectedRowKeys=[];
            that.$refs.table.refresh();
          }
        }
      });
    },
    batchisRead(){
      if (this.rowKeys.length>0) {
        if (this.selectedRowKeys.length>0) {
           this.setReadOrDel(this.selectedRowKeys.join(','),1);
        }
        this.selectedRowKeys=[];
        this.$refs.table.refresh();
      }
    },
    batch(e){
      console.log(e);
      if (this.rowKeys.length>0&&e.target.checked) {
        console.log(this.rowKeys);
        this.selectedRowKeys=Object.assign([],this.rowKeys);
      }else if(this.rowKeys.length>0&&!e.target.checked){
        this.selectedRowKeys=[];
      }
    },
    expandedRowsChange(record){//展开事件
      if (record&&record.length>0) {
        this.d.map(m=>{
          if (record.includes(m.id)) {
            m.content="";
            if (m.is_read==0) {
              this.isRead(m.id);
            }
          }else{
            m.content=m.content1;
          }
        })
        console.log(record);
      }else{
        this.d.map(m=>{
          m.content=m.content1;
        })
      }

    }
  },
  computed: {
    rowSelection() {
      const { selectedRowKeys } = this;
      return {
        selectedRowKeys:this.selectedRowKeys,
        onChange: (selectedRowKeys, selectedRows) => {
          console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows);
          this.selectedRowKeys=selectedRowKeys;   
        },
        getCheckboxProps: record => ({//设置单选框可选不可选
          props: {
            // disabled: record.is_read === '1',
            // name: record.id,
          }
        }),
      }
    }
  },
};
</script>

<style lang="scss" scoped>
@import "~@/components/layout/style/mixin.scss";
.notify-content {
  & /deep/ .ant-breadcrumb {
    margin: 16px 0;
    font-size: 18px;
    color: #333;
    font-weight: bold;
  }
  .search {
    & /deep/ .ant-form-item-label label {
      font-size: 13px;
      color: #999;
    }
    & /deep/ .ant-form-item-children {
      & .ant-btn,
      & .ant-input,
      & .ant-select-selection {
        font-size: 13px;
        border-radius: 0;
      }
    }
  }
  & /deep/ .ant-table-body {
    .content1{
      text-align: left; 
      display: block;
      width: 90%;
      float: right;
      padding-right: 7%;
    }
    border-top: 1px solid #dcdcdc;
    border-radius: 0;
    .ant-table-thead {
      & > tr > th {
        padding: 8px 16px;
        text-align: center;
      }
      & > tr > th:nth-child(1) {
        display: none;
        width:0px;
        padding: 0px;
      }
      & > tr > th:nth-child(2) {
        width:20px;
      }
      & > tr > th:nth-child(3) {
        width:60px;
      }
      & > tr > th:nth-child(4) {
        width: 100px;
        text-align: center;
      }
      & > tr > th:nth-child(5) {
        width: 450px;
        text-align: center;
      }
      & > tr > th:nth-child(6) {
        width: 128px;
        text-align: center;
      }
    }

    .ant-table-tbody {
      .ant-table-row-expand-icon {
        display: none;
      }
      tr {
        pointer-events:auto;
        &.ant-table-expanded-row{
          background:#fff;
          &>td{
            border-top:none;
          }
        }
        &:nth-child(even) {
          //background: #f8fdff;
        }
        &>td {
          padding: 9px 0px;
          text-align: center;
          border-top: 1px solid #f1f0f0;
          border-bottom: none;
        }
        &>td:nth-child(1){
          display: none;
          padding: 0px;
          width: 0px;
        }
        &>td:nth-child(5){
          text-align: left;
        }
        .content-span {
          display: inline-block;
          height: 30px;
          line-height: 30px;
          overflow: hidden;
          text-overflow:ellipsis;
          white-space: nowrap;
          width: 400px;
        }
      }
    }
  }
  & /deep/ .ant-table-pagination {
    float: none;
  }
  .detail {
    .goback {
      border-radius: 0;
      color: #008cd6;
      background-color: #d3effb;
      border-color: #d3effb;
      margin-top: 20px;
    }
    & > div {
      &:nth-child(2) {
        display: flex;
        margin: 20px 0 10px;
        border-bottom: 1px solid #dfe5eb;
        & > span {
          &:nth-child(1) {
            font-size: 20px;
            flex: 1;
          }
          &:nth-child(2) {
            font-size: 12px;
            color: #bababa;
          }
        }
      }
      &:nth-child(3) {
        display: flex;
        margin: 20px 0 10px;
        border-bottom: 1px solid #dfe5eb;

        & > div {
          &:nth-child(1) {
            flex: 1;
            color: #666;
            font-size: 13px;
            p {
              font-weight: bold;
              span {
                font-weight: normal;
              }
            }
          }
          &:nth-child(2) {
            padding: 0 20px;
            img {
              width: 70px;
              height: 70px;
              display: block;
              margin: auto;
              border: none;
              border-radius: 50%;
            }
            & /deep/ .ant-btn {
              margin: 8px 0 0;
              color: #999999;
              font-size: 12px;
              border-radius: 50px;
              background-color: #f9f9f9;
              i {
                color: #ff6b6b;
              }
            }
          }
        }
      }

      &:nth-child(4) {
        color: #666;
        font-size: 13px;
        p {
          font-weight: bold;
        }
        span {
          line-height: 24px;
        }
      }
    }
  }
  & /deep/ .ant-pagination {
    float: right;
  }
}
.board_title{
  border-bottom: 1px solid #dcdcdc;
  padding-bottom: 15px;
  p {
    color: #333;
    font-size: 18px;
    margin-bottom: 5px;
  }
}
.board_title2{
  color: rgb(102,102,102);
  font-size: 13px;
  margin-top: 22px;
  margin-bottom: 22px;
  &>:first-child{
    height: 26px;
    line-height: 26px;
    width: 80px;
    text-align: center;
    display: inline-block;
    background-color: rgb(227, 227, 227);
  }
  &>:nth-child(2){
    margin-left: 1px;
    height: 26px;
    line-height: 26px;
    width: 80px;
    text-align: center;
    display: inline-block;
    background-color: rgb(227, 227, 227);
  }
  &>.active{
    background-color: #f5cb13;
    color: rgb(255, 255, 255);
  }
}
.board_end{
  border-top: 1px solid #f1f0f0;
  color: rgb(102,102,102);
  font-size: 35px;
  margin-top: -59px;
  &>:nth-child(1){
    float: left;
    margin-top: 6px;
    margin-left: 13px;
    height: 26px;
    line-height: 26px;
    width: 80px;
    text-align: center;
    display: inline-block;
    & /deep/ .ant-checkbox-wrapper{
      &>span{
        color: #008cd6;
      }
    }
  }
  &>:nth-child(2){
    float: left;
    margin-top: 6px;
    margin-left: 1px;
    height: 26px;
    line-height: 26px;
    width: 80px;
    text-align: center;
    display: inline-block;
  }
  &>:nth-child(3){
    float: left;
    margin-top: 6px;
    margin-left: 1px;
    height: 26px;
    line-height: 26px;
    width: 80px;
    text-align: center;
    display: inline-block;
  }
}
 .icon-isnotread {
    @include menu-icon;
    background-position: -480px -660px ;
}
 .icon-isread {
    @include menu-icon;
    background-position: -500px -660px ;
}
 .icon-del {
    margin: auto 60px !important;
    @include menu-icon;
    background-position: -520px -660px ;
}
</style>
